import {Breadcrumbs} from '@primer/react'

import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'

import {mcpDetailsRoute} from '../mcp-details-route'

import {About} from './_components/About/About'
import {Sidebar} from './_components/Sidebar/Sidebar'

import styles from './McpDetails.module.css'

export function McpDetails() {
  const payload = useRouteQuery(mcpDetailsRoute, 'mainQuery')
  const {server_data, isLoggedIn} = payload.data
  const mcp = server_data

  return (
    <div className={`${styles.container} ${isLoggedIn ? '' : 'tmp-pt-5'}`}>
      {isLoggedIn ? null : (
        <Breadcrumbs>
          <Breadcrumbs.Item href="/mcp" className="fgColor-muted text-underline">
            MCP registry
          </Breadcrumbs.Item>
          <Breadcrumbs.Item href="#" selected>
            {mcp.display_name}
          </Breadcrumbs.Item>
        </Breadcrumbs>
      )}

      <div className={styles.hideOnDesktop}>
        <About mcp={mcp} />
      </div>

      <div className={styles.content}>
        <div className="js-snippet-clipboard-copy-unpositioned" data-hpc>
          {mcp.repository?.parsed_readme ? (
            <VerifiedHTMLDiv className="markdown-body" html={mcp.repository.parsed_readme} />
          ) : (
            <div className="markdown-body color-fg-muted">
              <p>No README available</p>
            </div>
          )}
        </div>

        <Sidebar mcp={mcp} />
      </div>
    </div>
  )
}
